/**
 * SectorBox – tabs.
 */
class SectorBoxTabs {

	/**
	 * @param {HTMLElement} container
	 */
	constructor( container ) {

		this.container = container;
		this.tabsPanel = container.querySelector( '.b-tabs-panel' );

		this.tabContents = Array.from(
			container.querySelectorAll( ':scope .b-sector-box__inner > .b-tab-content, :scope .b-tab-content' )
		);

		this.tabButtons = Array.from(
			container.querySelectorAll( '.b-tabs-panel__button' )
		);

		if ( this.tabsPanel && this.tabButtons.length ) {

			this.bindTabEvents();

		}

	}

	/* ------------------------------------------------------------------ */
	/* Tabs */
	/* ------------------------------------------------------------------ */

	/**
	 * Binds click events to tab buttons and back button.
	 */
	bindTabEvents() {

		this.btnHandlers = this.tabButtons.map( ( btn, index ) => {

			/** @return {void} */
			const handler = () => this.openTab( index );

			btn.addEventListener( 'click', handler );

			return { btn, handler };

		} );

		this.backHandler = ( event ) => {

			if ( event.target.closest( '.js-tab-back' ) ) {

				this.closeTab();

			}

		};

		this.container.addEventListener( 'click', this.backHandler );

	}

	/* ------------------------------------------------------------------ */
	/* Tab rendering */
	/* ------------------------------------------------------------------ */

	/**
	 * Shows the tab at the given index and hides the tab panel.
	 *
	 * @param {number} index Tab index.
	 */
	openTab( index ) {

		this.tabContents.forEach( ( content, i ) => {

			const isVisible = i === index;

			content.classList.toggle( 'is-hidden', !isVisible );
			content.setAttribute( 'aria-hidden', ( !isVisible ).toString() );

		} );

		this.tabsPanel.classList.add( 'is-hidden' );

		this.tabButtons.forEach( ( btn, i ) => {

			const isActive = i === index;

			btn.classList.toggle( 'is-active', isActive );
			btn.setAttribute( 'aria-selected', isActive.toString() );
			btn.setAttribute( 'tabindex', isActive ? '0' : '-1' );

		} );

	}

	/**
	 * Hides all tab contents and restores the tab panel.
	 */
	closeTab() {

		this.tabContents.forEach( ( content ) => {

			content.classList.add( 'is-hidden' );
			content.setAttribute( 'aria-hidden', 'true' );

		} );

		this.tabsPanel.classList.remove( 'is-hidden' );

		this.tabButtons.forEach( ( btn ) => {

			btn.classList.remove( 'is-active' );
			btn.setAttribute( 'aria-selected', 'false' );
			btn.setAttribute( 'tabindex', '0' );

		} );

	}

	/* ------------------------------------------------------------------ */
	/* Cleanup */
	/* ------------------------------------------------------------------ */

	/**
	 * Removes all event listeners and unlocks body scroll.
	 */
	destroy() {

		if ( this.btnHandlers ) {

			this.btnHandlers.forEach( ( { btn, handler } ) => {

				btn.removeEventListener( 'click', handler );

			} );

		}

		if ( this.backHandler ) {

			this.container.removeEventListener( 'click', this.backHandler );

		}

	}

}

/**
 * Initialize all sector-box instances.
 */
function initSectorBoxes() {

	document.querySelectorAll( '.b-sector-box' ).forEach( ( el ) => {

		new SectorBoxTabs( el );

	} );

}

if ( document.readyState === 'loading' ) {

	document.addEventListener( 'DOMContentLoaded', initSectorBoxes );

} else {

	initSectorBoxes();

}
